<template>
  <div class='table-box'>
    <global-tag>
      <el-form label-width='90px' :model='formData'>
        <el-row>
          <el-col :span='5'>
            <el-form-item label='对端号码：'>
              <el-input
                v-model='formData.remoteNum'
                clearable
                placeholder='请输入'
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col
            :span='9'
            style='display: flex; align-items: center'
          >
            <el-form-item label='日期：'>
              <el-date-picker
                v-model='formData.startTimeStr'
                type='datetime'
                format='yyyy-MM-dd HH:mm:ss'
                value-format='yyyy-MM-dd HH:mm:ss'
                placeholder='请输入开始时间'
              ></el-date-picker>
            </el-form-item>
            <div style='margin-bottom: 22px'>至</div>
            <el-form-item label-width='0' prop='endTimeStr'>
              <el-date-picker
                v-model='formData.endTimeStr'
                type='datetime'
                format='yyyy-MM-dd HH:mm:ss'
                value-format='yyyy-MM-dd HH:mm:ss'
                placeholder='请输入结束时间'
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span='5'>
            <el-form-item label='是否小结：'>
              <el-select
                v-model='formData.issummary'
                placeholder='请选择'
              >
                <el-option
                  label='已小结'
                  value='1'
                ></el-option>
                <el-option
                  label='未小结'
                  value='0'
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='5'>
            <el-form-item label='通话类型：'>
              <el-select
                clearable
                placeholder='请选择'
                v-model='formData.outCall'
              >
                <el-option
                  label='呼入'
                  value='0'
                ></el-option>
                <el-option
                  label='呼出'
                  value='1'
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span='5'>
            <el-form-item label='机构:'>
              <el-cascader
                :key='isRescourceShow'
                :options='orgTree'
                v-model='formData.orgId'
                :show-all-levels='false'
                :props="{
                                            checkStrictly: true,
                                            emitPath: false,
                                            label: 'label',
                                            value: 'orgId',
                                        }"
                clearable
              >
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span='3' :offset='1'>
            <el-button
              type='primary'
              class='searchBtns'
              @click='getTableData'
            >查询
            </el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </global-tag>
    <div>
      <el-table
        :data='tableData'
        border
        style='width: 100%'
        :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
      >
        <el-table-column
          width='60'
          type='index'
          label='序号'
          show-overflow-tooltip
          align='center'
        ></el-table-column>
        <el-table-column
          prop='loginName'
          show-overflow-tooltip
          label='登录名'
          align='center'
        ></el-table-column>
        <el-table-column
          prop='extNum'
          show-overflow-tooltip
          label='坐席号'
          align='center'
        ></el-table-column>
        <el-table-column
          prop='startTime'
          show-overflow-tooltip
          label='来电时间'
          align='center'
        ></el-table-column>
        <!-- <el-table-column prop="name" label="姓名" align="center">
            <template slot-scope="scope">
                <el-link
                    style="color: #038df5"
                    v-if="scope.row.name !== '未知来电'"
                    @click="seeInfor(scope.row)"
                >
                    {{ scope.row.name }}
                </el-link>
                <span v-if="scope.row.name === '未知来电'">{{
                    scope.row.name
                }}</span>
            </template>
        </el-table-column> -->
        <el-table-column
          prop='customerName'
          show-overflow-tooltip
          label='老人姓名'
          align='center'
        >
          <template slot-scope='scope'>
            <el-link v-if='scope.row.customerName == null'>
              未知
            </el-link>
            <span v-if='scope.row.customerName != null'>{{
                scope.row.customerName
              }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop='remoteNum'
          show-overflow-tooltip
          label='对端号码'
          align='center'
        ></el-table-column>
        <el-table-column
          prop='connectTimeLen'
          show-overflow-tooltip
          label='通话时长'
          align='center'
        ></el-table-column>
        <el-table-column prop='callID' label='通话类型' align='center'>
          <template slot-scope='scope'>
            <span v-if="scope.row.outCall == '1'">呼出</span>
            <span v-if="scope.row.outCall == '0'">呼入</span>
          </template>
        </el-table-column>
        <el-table-column
          align='center'
          prop='connectFlag'
          label='是否接通'
        >
          <template slot-scope='scope'>
            <span v-if="scope.row.connectFlag == '1'">已接通</span>
            <span v-else>未接通</span>
          </template>
        </el-table-column>
        <el-table-column
          align='center'
          prop='issummary'
          show-overflow-tooltip
          label='是否已小结'
        >
          <template slot-scope='scope'>
            <span v-if="scope.row.issummary == '0'">未小结</span>
            <span v-if="scope.row.issummary == '1'">已小结</span>
          </template>
        </el-table-column>
        <el-table-column label='操作' align='center' width='150'>
          <template slot-scope='scope'>
            <!--  -->
            <el-button
              v-if='scope.row.issummary != 1'
              type='text'
              @click='summary(scope.row.callID, scope.row)'
            >小结
            </el-button>
            <el-button
              type='text'
              @click='downloadSound(scope.row)'
              v-if="scope.row.connectFlag == '1'"
            >下载
            </el-button
            >
            <!-- <template v-if="scope.row.fileName">
                <el-button
                    v-if="scope.row.luyin"
                    type="text"
                    @click="sound(scope.row)"
                    >录音</el-button
                >
                <el-button
                    v-if="!scope.row.luyin"
                    type="text"
                    @click="stopplayer(scope.row)"
                    >暂停</el-button
                > -->
            <!-- </template> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style='margin-top: 15px'
        background
        @size-change='handleSizeChange'
        @current-change='handleCurrentChange'
        :current-page='pageConfig.pageNo'
        :page-sizes='[5, 10, 20, 50]'
        :page-size='pageConfig.pageSize'
        layout='total, sizes, prev, pager, next, jumper'
        :total='pageConfig.total'
      >
      </el-pagination>
    </div>

    <!--弹窗-->
    <el-dialog
      :close-on-click-modal='false'
      title='话务小结'
      :visible.sync='dialogFormVisible'
      :modal-append-to-body='false'
      :before-close='onDialogClose'
      width='40%'
    >
      <el-form :model='summerForm' label-width='80px'>
        <el-form-item label='通话类型:'>
          <!-- <el-cascader v-model="summerForm.region" :options="summerTypeList" :show-all-levels="false"></el-cascader> -->
          <el-select
            disabled
            v-model='summerForm.callType'
            :show-all-levels='false'
          >
            <el-option label='呼入' value='0'></el-option>
            <el-option label='呼出' value='1'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='坐席姓名:'>
          <el-input
            disabled
            v-model='summerForm.userName'
            autocomplete='off'
          ></el-input>
        </el-form-item>
        <el-form-item label='通话小结:'>
          <el-input
            v-model='summerForm.remark'
            type='textarea'
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot='footer' class='dialog-footer'>
        <el-button @click='onDialogClose'>取 消</el-button>
        <el-button type='primary' @click='summerSubmit'
        >确 定
        </el-button
        >
      </div>
    </el-dialog>
    <!--    录音弹框-->
    <el-dialog
      :before-close='musicDialogClose'
      title='录音听取'
      :visible.sync='music'
      :modal-append-to-body='false'
      :close-on-click-modal='false'
      width='35%'
    >
      <audio
        controls='controls'
        style='margin: 10px 25%'
        autoplay='autoplay'
        :src='audioSrc'
      ></audio>
    </el-dialog>
  </div>
</template>

<script>
let iantooMusic = new Audio()
import request from '@/utils/request.js'
import { post } from '@/api/requrestHttp'
import headLine from '../components/headline'
import audioLink from '@/api/audio'
import saveAs from 'file-saver'

export default {
  components: {
    headLine
  },
  data() {
    return {
      provinceList: [], //省列表
      cityList: [], //市列表
      areaList: [], //区列表
      streetList: [], //街道列表
      communityList: [], //社区列表
      myMap: null, //地图
      formData: {
        provinceId: '', //省地址
        cityid: '', //市地址
        zoneid: '', //区地址
        streetid: '', //街道地址
        shequid: '', //社区地址
        startTimeStr: '',
        endTimeStr: ''
      },
      tableData: [],
      pageConfig: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      info: '',
      isRescourceShow: 0,
      // 机构树
      orgTree: [],
      infoPhone: '',
      infor: false,
      summerTypeList: [],
      dialogFormVisible: false,
      summerForm: {
        calltype: '',
        remark: ''
      },
      username: this.$store.state.info.name,
      clickType: '',
      clickId: '',
      ghocxIp: '192.168.5.5',
      music: false,
      audioSrc: '',
      isSearchContent: true
    }
  },
  created() {
    this.setDate()

    this.getTableData()
    this.getProvince()
    this.handleProvince()
    this.getOrgTree()
  },
  watch: {
    orgTree() {
      ++this.isRescourceShow

      // console.log(this.isRescourceShow)
    }
  },
  methods: {
    Reset() {
      this.formData = {}
      this.getTableData()
    },
    setDate() {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hh = date.getHours()
      let mm = date.getMinutes()
      let ss = date.getSeconds()

      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      if (hh < 10) {
        hh = '0' + hh
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      if (ss < 10) {
        ss = '0' + ss
      }
      let time1 = date.getTime(
        year + '-' + month + '-' + day + ' 00:00:00'
      )
      let time2 = time1 - 7 * 24 * 60 * 60 * 1000
      let date2 = new Date(time2)
      // console.log(date2)

      let year_ = date2.getFullYear()
      let month_ = date2.getMonth() + 1
      let day_ = date2.getDate()
      if (month_ < 10) {
        month_ = '0' + month_
      }
      if (day_ < 10) {
        day_ = '0' + day_
      }

      this.formData.startTimeStr =
        year_ + '-' + month_ + '-' + day_ + ' 00:00:00'

      // this.formData.startTimeStr = "2021-12-20 00:00:00"

      this.formData.endTimeStr =
        year + '-' + month + '-' + day + ' ' + hh + ':' + mm + ':' + ss
      // console.log(this.formData.startTimeStr, this.formData.endTimeStr)
    },
    // 获取机构树
    async getOrgTree() {
      // const { content } = await post(
      //     "/rbac/admin/org/info/OrgTreeForOrgIdlist",
      //     {
      //         isValid: 1,
      //     }
      // )
      // this.orgTree = content;
      this.$post('/rbac/admin/org/info/OrgTreelist', { isValid: 1 }).then(
        (res) => {
          if (res.code === 200) {
            //当前账号绑定的机构所有下级
            let treeList = []
            this.orgTree = this.chbehavior(
              res.content,
              this.$store.state.info.orgId
            )
            if (!this.orgTree.children) {
              //当前账号绑定的机构下级&自己数据
              treeList.push({
                label: this.orgTree.label,
                orgId: this.orgTree.orgId
              })
              this.orgTree = treeList
            } else {
              treeList.push({
                label: this.orgTree.label,
                orgId: this.orgTree.orgId,
                children: this.orgTree.children
              })
              this.orgTree = treeList
            }
          }
        }
      )
    },
    chbehavior(arr, id) {
      let res
      ;(function deepId(arr, id) {
        for (let a of arr) {
          if (a.orgId == id) {
            res = a
          } else if (a.children && !res) {
            deepId(a.children, id)
          }
        }
      })(arr, id)
      return res
    },
    stopplayer(row) {
      // 停止播放音频
      row.luyin = true
      // this.music=false
      iantooMusic.pause()
    },
    downloadSound(row) {
      request({
        url: '/jjyl/trafficRecFile/info/get',
        method: 'POST',
        data: {
          callID: row.callID
        }
        //responseType: "blob",
      }).then((res) => {
        if (res.code == '200') {
          // window.open(audioLink + "/" + res.content.fileName)
          window.location.href =
            audioLink + '/' + res.content.fileName
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 录音弹框关闭
    musicDialogClose() {
      this.music = false
      this.audioSrc = ''
    },
    // 显示录音弹框
    sound(row) {
      // 开始播放音频
      if (row.fileName) {
        // window.console.log(row.fileName)
        this.music = true
        row.luyin = false
        this.audioSrc =
          'http://' +
          this.ghocxIp +
          '/downbyname.php?name=' +
          row.fileName
      } else {
        this.$message(row.fileName + '文件不存在')
      }
    },
    // 话务小结提交
    summerSubmit() {
      if (this.summerForm.remark && this.summerForm.callType) {
        // this.metaDataMgrDaos()
        this.submitSummer()
      } else {
        this.$message.error('请将信息填写完整！')
      }
    },
    // 话务小结弹窗关闭
    onDialogClose() {
      this.dialogFormVisible = false
      this.username = ''
      this.summerTypeList = []
      this.summerForm = {
        remark: '',
        callType: ''
      }
      this.clickType = ''
      this.clickId = ''
    },
    // 显示话务小结弹窗
    summary(id, row) {
      this.info = []
      this.infoShow = false
      this.clickId = id
      this.callmanid = row.loginId
      this.dialogFormVisible = true
      this.summerForm.callType = row.outCall
      this.summerForm.userName = row.userName
      this.summerForm.remark = row.remark
    },
    submitSummer() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      request({
        url: '/jjyl/callSummary/info/update',
        method: 'POST',
        data: {
          callid: this.clickId,
          calltype: this.summerForm.callType,
          remark: this.summerForm.remark,
          callmanid: this.callmanid,
          callman: this.summerForm.loginName,
          userName: this.summerForm.userName
        }
      })
        .then((resp) => {
          if (resp.code == '200') {
            loading.close()
            this.dialogFormVisible = false
            this.$message({
              message: resp.message,
              type: 'success'
            })
            this.summerForm.remark = ''
            this.dialogFormVisible = false
          } else if (resp.code == '500') {
            loading.close()
            this.$message('系统异常，请稍后重试')
            this.tableData = this.tableData.concat(null)
            this.loading = false
          }
        })
        .catch((error) => {
          this.dialogFormVisible = false
          loading.close()
        })
    },
    // getFindReturnTree() {
    //     request({
    //         url: "/jjyl/return/info/findReturnTree",
    //         method: "POST",
    //         data: {
    //             isCall: 1,
    //             username: this.$store.state.info.name,
    //             outCall: this.clickType,
    //             belongAddressId: "1856cf78-bd6a-45bf-afd4-b553f3da443f",
    //         },
    //     }).then((resp) => {
    //         if (resp.code == "200") {
    //             if (resp.content != null) {
    //                 console.log(resp)
    //                 let arry = []
    //                 resp.content.sublist.forEach((item) => {
    //                     let obj = {}
    //                     if (item.sublist) {
    //                         let subArr = []
    //                         item.sublist.forEach((items) => {
    //                             let subobj = {
    //                                 value: items.name,
    //                                 label: items.name,
    //                             }
    //                             subArr.push(subobj)
    //                         })
    //                         obj = {
    //                             value: item.name,
    //                             label: item.name,
    //                             children: subArr,
    //                         }
    //                     } else {
    //                         obj = {
    //                             value: item.name,
    //                             label: item.name,
    //                         }
    //                     }
    //                     arry.push(obj)
    //                 })
    //                 console.log(arry)
    //                 this.summerTypeList = arry
    //             } else {
    //                 // this.$message("暂无数据")
    //                 console.log(resp)
    //             }
    //         } else if (resp.code == "500") {
    //             // this.$message("系统异常，请稍后重试")
    //             this.tableData = this.tableData.concat(null)
    //             this.loading = false
    //         } else {
    //             this.$alert("认证失败，重新登录！", "系统提示", {
    //                 confirmButtonText: "确定",
    //                 cancelButtonText: "取消",
    //                 type: "warning",
    //                 callback: (action) => {
    //                     this.$router.push({ path: "/login" })
    //                 },
    //             })
    //         }
    //     })
    // },
    getCallsummary() {
      request({
        url: '/jjyl/callSummary/info/getCallSummaryByCallman',
        method: 'POST',
        data: {
          callmanid: this.clickId
        }
      }).then((resp) => {
        // console.log(resp.code)
        if (resp.code == 200) {
          if (resp.content != null) {
            this.summerForm.CallID = resp.content.calltypedes
            this.summerForm.content = resp.content.remark
            this.username = resp.content.callman
          } else {
            this.summerForm.content = ''
          }
        } else if (resp.code == '500') {
          this.$message('系统异常，请稍后重试')
          this.tableData = this.tableData.concat(null)
          this.loading = false
        } else {
          // this.$alert("认证失败，重新登录！", "系统提示", {
          //     confirmButtonText: "确定",
          //     cancelButtonText: "取消",
          //     type: "warning",
          //     callback: (action) => {
          //         this.$router.push({ path: "/login" })
          //     },
          // })
        }
      })
    },
    // 查看信息
    seeInfor(row) {
      // console.log(row.remoteNum)
      this.infoId = row.id
      this.infoPhone = row.remoteNum
      this.infor = true
    },
    // 分页
    handleSizeChange(val) {
      this.pageConfig.pageSize = val
      this.getTableData()
    },
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val
      this.getTableData()
    },
    getTableData(params = {}) {
      // console.log(this.formData.startTimeStr)
      let data = Object.assign(
        {
          //  isCall: 1,
          //  agentId: this.$store.state.info.name,
          pageNo: this.pageConfig.pageNo,
          pageSize: this.pageConfig.pageSize,
          innerCall: this.formData.innerCall,
          startTimeStr: this.formData.startTimeStr,
          endTimeStr: this.formData.endTimeStr,
          orgId: this.formData.orgId,
          issummary: this.formData.issummary,
          outCall: this.formData.outCall,
          remoteNum: this.formData.remoteNum
        },
        params
      )
      // console.log(data)
      this.$http
        .request({
          url: '/jjyl/traffic/callInfo/info/findCallRecordList',
          method: 'POST',
          data
        })
        .then((res) => {
          if (res.code === 200 && res.content) {
            const arr = res.content.list || []
            // arr.forEach((item) => {
            //     item.luyin = true
            // })
            this.tableData = arr
            this.pageConfig.total = res.content.count || 0
          } else {
            this.tableData = []
            this.pageConfig.total = 0
          }
        })
    },
    timeFormatter(row, column) {
      let time = row.timeLen
      if (time) {
        let theTime = parseInt(time) // 秒
        let theTime1 = 0 // 分
        let theTime2 = 0 // 小时
        if (theTime > 60) {
          theTime1 = parseInt(theTime / 60)
          theTime = parseInt(theTime % 60)
          if (theTime1 > 60) {
            theTime2 = parseInt(theTime1 / 60)
            theTime1 = parseInt(theTime1 % 60)
          }
        }
        let result = '' + parseInt(theTime) + '秒'
        if (theTime1 > 0) {
          result = '' + parseInt(theTime1) + '分' + result
        }
        if (theTime2 > 0) {
          result = '' + parseInt(theTime2) + '小时' + result
        }
        return result
      }
      return '0秒'
    },
    isSummaryFormat(row, column) {
      // if (row.issummary === "0") {
      //     return "未小结"
      // } else if (row.issummary === "1") {
      //     return "已小结"
      // }
    },

    //获取地址
    getDistrict(name = '中国', params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: 'all',
          showbiz: false //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: '', //城市设为北京，默认：“全国”
          radius: 1000 //范围，默认：500
        })
        district.search(name, (status, result) => {
          if (status == 'complete') {
            resolve(result.districtList[0])
          }
        })
      })
    },
    //获取省级
    async getProvince() {
      this.provinceLis = []
      this.cityList = []
      this.areaList = []
      this.streetList = []
      let province = await this.getDistrict()
      this.provinceList = province.districtList
    },
    //  省级地址选择发生改变
    async handleProvince(val) {
      this.cityList = []
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.formData.cityid = ''
      this.formData.zoneid = ''
      this.formData.streetid = ''
      this.formData.shequid = ''
      this.formData.address = ''
      let city = await this.getDistrict(val)
      this.cityList = city.districtList
    },
    //市级地址发生改变
    async handleCity(val) {
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.formData.zoneid = ''
      this.formData.streetid = ''
      this.formData.shequid = ''
      this.formData.address = ''
      let area = await this.getDistrict(val)
      this.areaList = area.districtList
    },
    //县区级地址发生改变
    async handleArea(val) {
      this.streetList = []
      this.communityList = []
      this.formData.streetid = ''
      this.formData.shequid = ''
      this.formData.address = ''
      // val = val.replace(/.$/, "");
      let street = await this.getDistrict(val)
      this.streetList = street.districtList
    },
    //街道地址发生变化
    streetChange(val, flag = null) {
      this.communityList = []
      if (!flag) {
        this.formData.shequid = ''
      }
      this.$http
        .request({
          url: '/ypt/admin/standardAddress/info/StandardAddressTree',
          method: 'POST',
          data: {
            pageSize: 1000,
            pageNo: 1,
            jiedaoId: val
          }
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == 'null') {
              this.communityList = []
              return
            }
            this.communityList = res.content.list
          }
        })
    }
  }
}
</script>

<style lang='less' scoped>
.elder_manage_title {
  position: relative;
  width: 100%;
  margin-bottom: 15px;

  &::after {
    position: absolute;
    left: 120px;
    right: 0;
    display: block;
    content: "";
    border-bottom: 1px solid #e4e7ed;
  }

  .title {
    box-sizing: border-box;
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #409eff;
    font-size: 14px;
    border: 1px solid #e4e7ed;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
    background: #ffffff;
  }
}

.searchDomw {
  cursor: pointer;
}
</style>
